export default function readWithPagination<Item>(
  existing: Item[],
  { args }: { args: Record<string, number> | null },
) {
  const page = args?.page ?? 0
  const limit = args?.limit ?? existing?.length ?? 0
  return existing && existing.slice(0, (page + 1) * limit)
}
